import Typography from "@mui/material/Typography";
import { MainCard } from "../components/MainCard";

/**
 * Placeholder for the ~9 admin surfaces NOT in this evaluation build's "half the work" scope
 * (docs/337-ADMIN-MANTIS-MIGRATION.md v1 §"HALF THE WORK": only People, Invites, and Provider
 * Settings are real pages here). The existing `apps/admin`/`apps/admin-web` stay the way to reach
 * these in the meantime — this is a look/feel candidate, not a cutover.
 */
export function ComingSoonPage({ title }: { title: string }) {
  return (
    <MainCard title={title}>
      <Typography color="text.secondary" sx={{ mb: 0 }}>
        Not part of this Mantis evaluation build yet (docs/337 v2) — use{" "}
        <code>apps/admin-web</code> (or the RN admin) for this tab in the meantime.
      </Typography>
    </MainCard>
  );
}
